import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Col from '../col';
import Row from '../row';
import Button from '../button';
import './style';

const propTypes = {
  collapsed: PropTypes.bool,
  children: PropTypes.node.isRequired,
  layout: PropTypes.shape(Col.propTypes),
  content: PropTypes.node,
  maskClosable: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  collapsed: true,
  layout: {
    xs: { span: 23, offset: 1 },
    sm: { span: 16, offset: 8 },
    md: { span: 10, offset: 14 },
  },
  content: '',
  maskClosable: false,
  className: '',
};

function preventClick(e) {
  e.stopPropagation();
}

class SlidePanel extends React.Component {
  constructor(props) {
    super(props);
    this.handleMaskClose = this.handleMaskClose.bind(this);
  }

  handleMaskClose(e) {
    if (this.props.maskClosable) {
      this.props.handleClose();
    }
    e.stopPropagation();
  }

  render() {
    const {
      children, layout, content, collapsed, className,
    } = this.props;
    const panelClass = classnames(
      className, 'bsa-slide-panel__panel',
      {
        collapsed,
      },
    );
    const containerClass = classnames(
      'bsa-slide-panel__container',
      {
        hidden: collapsed,
      },
    );

    return (
      <div className="bsa-slide-panel">
        <Row className={containerClass} onClick={this.handleMaskClose}>
          <Col
            {...layout}
            className={panelClass}
            onClick={preventClick}
          >
            <div className="bsa-slide-panel__close-icon">
              <Button ghost icon="cross" fitText onClick={this.props.handleClose} />
            </div>
            {content}
          </Col>
        </Row>
        {children}
      </div>);
  }
}

SlidePanel.defaultProps = defaultProps;
SlidePanel.propTypes = propTypes;
export default SlidePanel;
